import React from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  row: {
    display: "flex",
    flexFlow: "row wrap",
    marginBottom: 16,
  },
  label: (props) => ({
    marginLeft: 0,
    marginRight: "auto",
    color: props.color || "inherit",
  }),
  value: (props) => ({
    fontWeight: 600,
    marginLeft: "auto",
    marginRight: 0,
    color: props.color || "inherit", // ここでprops.colorを使用
  }),
});

const TextDetail = (props) => {
  const classes = useStyles(props); // propsを渡す
  return (
    <div className={classes.row}>
      <div className={classes.label}>{props.label}</div>
      <div className={classes.value}>{props.value}</div>
    </div>
  );
};

export default TextDetail;
